<template>
	<section class="sub-colecao">
		<div class="tree-menu">
			<div class="row">
				<!-- Quando tem filho -->
				<div class="icon" v-on:click.stop="toggleChildren()" v-if="subColecoes.length > 0">
					<i v-bind:class="['fas', isOpen ? 'fa-minus' : 'fa-plus']"></i>
				</div>

				<!-- Quando não tem filho-->
				<div class="icon forbidden" v-else>
					<i class="fas fa-minus"></i>
				</div>

				<div class="checkbox">
					<label>
						<input type="checkbox" v-model="subColecao.checked" v-bind:id="subColecao.id">
						<div class="checkcustom">
							<span class="fas fa-check"></span>
						</div>
						<div> {{subColecao.nome}} </div>
					</label>
				</div>

			</div>

			<div v-if="showChildren">
				<SubColecoes v-for="(subColecao, index) in subColecoes" :key="$vnode.key + '.' + (index + 1)" :subColecoes="subColecao.subColecoes" :subColecao="subColecao" />
			</div>
		</div>
	</section>
</template>

<script>
import SubColecoes from './SubColecoes'
export default {
	name: 'SubColecoes',
	components: { SubColecoes },
	props: ['subColecoes', 'subColecao'],
	data () {
		return {
			showChildren: false,
			isOpen: false
		}
	},
	methods: {
		toggleChildren () {
			this.showChildren = !this.showChildren
			if (this.showChildren) {
				this.isOpen = true
			} else {
				this.isOpen = false
			}
		}
	}
}
</script>

<style lang="scss" scoped>
	.sub-colecao .sub-colecao {
		padding-left: 28px;

		& .tree-menu {
			border: none;
		}
	}

	.tree-menu {
		position: relative;
		margin-top: 5px;
		border-radius: 5px;
		border: 1px solid #EBECEF;
		background-color: #F8F9FB;

		.row {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex-wrap: wrap;
			padding: 8px 10px;
			font-size: .9em;

			.icon {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 20px;
				cursor: pointer;

				&.forbidden {
					cursor: not-allowed;
				}
			}

			.checkbox {

				label {
					display:flex;
					align-items: center;
					cursor: pointer;
				}
				margin: 0 20px 0 10px;
				input[type=checkbox] {
					position: absolute;
					opacity: 0;

					&:checked + .checkcustom {
						background-color: #8B94A7;
						border: 1px solid transparent;

						& span {
							transform: scale(1);
						}
					}
				}

				.checkcustom {
					display: flex;
					align-items: center;
					justify-content: center;
					height: 16px;
					width: 16px;
					border-radius: 2px;
					border: 1px solid #8B94A7;
					background-color: #F8F9FB;
					transition: .333s background-color;
					margin-right: 10px;
					cursor: pointer;

					& span {
						font-size: 10px;
						color: #FFF;
						transform: scale(0);
						transition: .333s transform;
						transform-origin: center;
					}
				}
			}
		}
	}
</style>
